import { deleteInsuranceOverviewDocument } from "api/Documents";
import { queryClient } from "lib/helpers/configs/queryClient";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { toast } from "react-toastify";

export const useDeleteOverviewDocument = () => {

    const { t } = useTranslation()

    return useMutation(deleteInsuranceOverviewDocument, {
        onSuccess: () => {
            queryClient.invalidateQueries("resources");

            toast.success(t("Deleted successfully"));
        },
        onError: () => {
            toast.error(t("Failed to delete"));
        },
    });
};
